const $          = require('jquery');
const _          = require('underscore');
const Backbone   = require('backbone');
const Mn         = require('../lib/marionette');
const Cache      = require('./cache');
const Controller = require('./controller');
const Router     = require('./router');
const UI         = require('./ui/main');
const Api        = require('./api');

const App = Mn.Application.extend({
    region:     '#app',
    Cache:      Cache,
    UI:         null,
    Api:        Api,
    Controller: Controller,
    version:    null,

    onStart: function (app, options) {
        console.log('Welcome to Dpkg');

        let self = this;

        Api.getPkgData()
            .then(result => {
                Cache.set(result);
            })
            .then(() => {
                this.UI = new UI();
                this.UI.on('render', () => {
                    // If successful, start the history and routing
                    new Router(options);

                    Backbone.history.start({});

                    // Remove loading class
                    $('#app').removeClass('loading');
                });

                this.getRegion().show(this.UI);
            })
            .catch(err => {
                console.error(err);
                self.trigger('after:start');
                self.UI = new UI();
                self.getRegion().show(self.UI);
            });
    },

    History: {
        replace: function (data) {
            window.history.replaceState(_.extend(window.history.state || {}, data), document.title);
        },

        get: function (attr) {
            return window.history.state ? window.history.state[attr] : undefined;
        }
    },

    Error: function (code, message, debug) {
        let temp     = Error.call(this, message);
        temp.name    = this.name = 'AppError';
        this.stack   = temp.stack;
        this.message = temp.message;
        this.code    = code;
        this.debug   = debug;
    },

    showError: function () {
        let ErrorView = Mn.View.extend({
            tagName:  'section',
            id:       'error',
            template: _.template('Error loading stuff. Please reload the app.')
        });

        this.getRegion().show(new ErrorView());
    }
});

const app = new App();
module.exports = app;
